import React from "react";
export const WeekRequestIcon = () => {
  return (

      <svg
          viewBox="0 0 24 24"
          fill="none"
          strokeWidth="2"
          stroke="#123262"
      >
        <rect width="3" height="8" x="2" y="12"  />
        <rect width="3" height="16" x="6" y="4" />
        <rect width="3" height="12" x="10" y="8"  />
        <rect width="3" height="10" x="14" y="10" />
        <rect width="3" height="6" x="18" y="14"/>
      </svg>
  );
};
